import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";

export const IconVisionProApp: React.NamedExoticComponent<CentralIconBaseProps> = React.memo(React.forwardRef<SVGSVGElement, CentralIconBaseProps>((props, ref) => {
  return <CentralIconBase {...props} ref={ref} ariaLabel={"vision-pro-app, window"} maskId="square-filled-radius-0-stroke-1-IconVisionProApp"><path fillRule="evenodd" clipRule="evenodd" d="M2 4H23V18H20V20H5L5 18H2L2 4ZM6 17.1429L6 19H19V17.1429H6ZM1 8V14H0V8H1Z" fill="currentColor"/></CentralIconBase>;
}));

export default IconVisionProApp;
